import {
  Component,
  HostBinding,
  Input
} from '@angular/core';
import { ListSpacing } from './list.enum';
import { PositionEnum } from '../../../_enums/position.enum';

@Component({
  selector: '[sd-list], [sd-list-block], [sd-list-inline], [sd-list-inline-group], [sd-list-ordered], [sd-list-arrow]',
  templateUrl: './list.component.html',
  standalone: true
})
export class SdListComponent {
  _alignement: PositionEnum.bottom | PositionEnum.center | PositionEnum.top =
    PositionEnum.center;
  listAlignement: string;
  _spacing: ListSpacing = ListSpacing.default;
  listSpacing: string;
  _size = false;
  childrenSize: string;

  @Input()
  get size() {
    return this._size;
  }
  set size(size: boolean) {
    this._size = size;
    if (size) {
      this.childrenSize = 'is-equal';
    }
  }

  @Input()
  get alignement() {
    return this._alignement;
  }
  set alignement(
    alignement: PositionEnum.bottom | PositionEnum.center | PositionEnum.top,
  ) {
    if (!alignement) {
      throw new Error(
        `The alignement you give is ${alignement}, use [alignement]="'bottom'" for example \n
         See all alignement ${PositionEnum.bottom} | ${PositionEnum.center} | ${PositionEnum.top}
      `,
      );
    }
    this._alignement = alignement;
    this.listAlignement = 'is-align-' + alignement;
  }

  @Input()
  get spacing() {
    return this._spacing;
  }
  set spacing(spacing: ListSpacing) {
    if (!spacing) {
      throw new Error(
        `The spacing you give is ${spacing}, use [spacing]="'xs'" for example \n
         See all spacing ${JSON.stringify(Object.keys(ListSpacing))}
      `,
      );
    }
    this._spacing = spacing;
    this.listSpacing = 'is-' + spacing;
  }

  @Input() class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.childrenSize,
      this.listAlignement,
      this.listSpacing
    ]
      .filter(Boolean)
      .join(' ');
  }
}
